import App from 'app/app.js';

function LtSubjectWithEventFilter(ContentStore) {
  return function (subject) {
    var firstName = subject.subjectFirstName ? subject.subjectFirstName : subject.subjectLastName;
    if (subject.studentId || subject.masterSubjectId) {
      return firstName + ' - ' + ContentStore.getContent(null, 'ID_TEXT') + ' #' + (subject.studentId || '');
    } else {
      var jobName = subject.currentEvent.event.jobName.toUpperCase().replace(' ', '_') + '_HEADER';
      var message = ContentStore.getContent(null, jobName);
      if (message != undefined) {
        return firstName + ' - ' + message.replace('{{year}}', subject.currentEvent.event.schoolYearDisplay);
      } else {
        return firstName + ' - ' + subject.currentEvent.event.schoolYearDisplay;
      }
    }
  };
}

App.filter('LtSubjectWithEventFilter', ['ContentStore', LtSubjectWithEventFilter]);
